import { getDataIdsFromContract } from '../../../core/utils/generateDataId';

export const NPS_DIALOG_DATA_IDS = getDataIdsFromContract({
  base: 'np-dialog',
  close: 'close',
  starIcon: 'star-icon',
  title: 'title',
  postSubmissionTitlePositive: 'post-submission-title-positive',
  postSubmissionTitle: 'post-submission-title',
  postSubmissionSubText: 'post-submission-sub-text',
  postSubmissionSubTextPositive: 'post-submission-sub-text-positive',
  postSubmissionSubTextNegative: 'post-submission-sub-text-negative',
  remindLater: 'remind-later',
  scheduleCall: 'schedule-call',
  reviewButton: 'review-button',
  reason: 'reason',
  comment: 'comment',
  starWidget: 'star-widget',
  submitButton: 'submit-button'
});
